document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".showtodaysdate");

  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric'
  });

  elements.forEach(el => {
    el.textContent = formattedDate;
  });
});

document.addEventListener("click", function(e){

  const toggle = e.target.closest(".u-collapsible-toggle");
  if(!toggle) return;

  const item = toggle.closest(".u-collapsible-item");
  const content = item.querySelector(".u-collapsible-content");

  // Close all other items
  document.querySelectorAll(".u-collapsible-item.active").forEach(function(openItem){
    if(openItem !== item){
      openItem.classList.remove("active");
      openItem.querySelector(".u-collapsible-content").style.maxHeight = null;
    }
  });

  item.classList.toggle("active");

  if(item.classList.contains("active")){
    setTimeout(() => {
      content.style.maxHeight = content.scrollHeight + "px";
    }, 50);
  }else{
    content.style.maxHeight = null;
  }

});



